import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { DealsService } from "../../../../auth/service/deals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomerService } from "../../../../modules/customer/customer.service";
import { CommissionService } from "../../../../auth/service/commission.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { IdealBE } from "../../../../auth/models/deal-inferface";
import { ProductDealsService } from "app/modules/products/products-deals.service";
import { IDealProductList } from "app/modules/products/models/products-deals";
import { ProductsCommissionsService } from "app/modules/products/products-commissions.service";
import { ICustomer } from "../../../../modules/customer/customer.interface";
import moment from "moment";

@Component({
  selector: "app-deals-list",
  templateUrl: "./deals-list.component.html",
  styleUrls: ["./deals-list.component.scss"],
})
export class DealsListComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public searchKey: string = "";
  public tableLimit: number = 10;
  public deals: Array<IdealBE | IDealProductList> = [];
  public filterDeals: Array<IdealBE> = [];
  public filter_commercial: any = "";
  public filter_typology: any = "";
  public filter_customer: number = 0;
  public commercial_list: any = [];
  public customers_list: ICustomer[] = [];
  public selectedCommissionID: number = null;
  public selectedDealId: number = null;
  public commissionList: any = [];
  public productCommissionList: any = [];
  public filteredCommissionList: any = [];

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _dealsService: DealsService,
    public _userService: UserService,
    private router: Router,
    private _customerService: CustomerService,
    private _commissionService: CommissionService,
    private _modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private _productsDealsService: ProductDealsService,
    private _productsCommissionsService: ProductsCommissionsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.DEALS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.ECONOMICS_DATA,
            isLink: false,
          },
          {
            name: italian.data.MENU.DEALS,
            isLink: false,
          },
        ],
      },
    };
    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const commercial = params.commercial;
      const type = params.type;
      const client = params.client;
      if (!!searchKey && searchKey != 0) {
        this.searchKey = searchKey;
      }
      if (!!commercial && commercial != 0) {
        this.filter_commercial = commercial;
      }
      if (!!type && type != 0) {
        this.filter_typology = type;
      }

      if (!!client && Number(client) > 0) {
        this.filter_customer = Number(client);
      }
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_deals")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.commissionList = await this._commissionService.getCommissions();
    this.productCommissionList = await this._productsCommissionsService.getCommissions();
    this.commercial_list = await this._userService.getList("employee", "Commerciale,Direzione", null, "avatar,hash,complete_name, role");
    this.customers_list = await this._customerService.getCustomers();
    this.customers_list = this.customers_list.sort((a, b) => (a.name > b.name ? 1 : -1));

    await this.loadDeals();
    await this.searchDeal();
    this._utilService.hideLoading();
  }

  async loadDeals() {
    this.deals = await this._dealsService.getDeals();
    if (this._utilService.moduleIsActive("products")) {
      const productDeals: IDealProductList[] = await this._productsDealsService.getDeals();
      if (productDeals && productDeals.length > 0) {
        this.deals = this.deals.concat(productDeals);
      }
    }
    this.deals = this.deals.sort((a, b) => (b.protocol > a.protocol ? 1 : -1));
  }

  async searchDeal() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filterDeals: any = this.deals;
    if (key.length > 0) {
      filterDeals = filterDeals.filter((item: any) => {
        const description = item.description;
        if (typeof description === "string") {
          return description?.toLowerCase().includes(key) || item.complete_name?.toLowerCase().includes(key);
        }
        if (Array.isArray(description)) {
          return JSON.stringify(description).toLowerCase().includes(key) || item.complete_name?.toLowerCase().includes(key);
        }

        return false;
      });
    }
    if (this.filter_typology) {
      filterDeals = filterDeals.filter((item: any) => item.deal_type === this.filter_typology);
    }
    if (this.filter_commercial) {
      filterDeals = filterDeals.filter((item: any) => item.commercial?.complete_name === this.filter_commercial);
    }
    if (this.filter_customer > 0) {
      filterDeals = filterDeals.filter((item: any) => item.client?.id === this.filter_customer);
    }

    filterDeals = filterDeals.map((item: any) => {

      if (item.from) {
        item.start_date = moment(item.from);
      } else {
        item.start_date = moment(item.start_date);
      }

      if (item.to) {
        item.end_date = moment(item.to);
      } else {
        item.end_date = moment(item.end_date);
      }

      return item;
    });

    this.filterDeals = filterDeals;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.searchKey && this.searchKey.length >= 3) {
      url.searchParams.set("search", String(this.searchKey));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.filter_commercial) {
      url.searchParams.set("commercial", this.filter_commercial);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("commercial");
      history.pushState({}, "", url);
    }

    if (!!this.filter_typology) {
      url.searchParams.set("type", this.filter_typology);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("type");
      history.pushState({}, "", url);
    }

    if (!!this.filter_customer && Number(this.filter_customer) > 0) {
      url.searchParams.set("client", String(this.filter_customer));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("client");
      history.pushState({}, "", url);
    }
  }

  async modalOpen(modalBasic, deal: any) {
    if (deal.deal_type === "Product") {
      this.filteredCommissionList = this.productCommissionList.filter((item: any) => item.client_id === deal.client.id && item.status === 0);
    } else {
      this.filteredCommissionList = this.commissionList.filter((item: any) => item.client_id === deal.client.id && item.status === 0);
    }
    if (!this.filteredCommissionList || this.filteredCommissionList.length < 1) {
      await this._utilService.showSWALError({ text: "NO_COMMISSION_FOR_SELECTED_CUSTOMER" });
      return false;
    }
    this.selectedDealId = deal.id;
    this._modalService.open(modalBasic, {
      size: "s,",
      centered: true,
    });
  }

  modalClose() {
    this.selectedCommissionID = null;
    this.selectedDealId = null;
    this._modalService.dismissAll();
  }

  updateTableLimit(event: any) {
    this.tableLimit = Number(event.target.value);
  }

  descriptionTooltip(description: any[]) {
    if (description && description.length > 0) {
      return description.join(", ");
    }
  }

  async goToCommission() {
    await this.router.navigate([`/dashboard/commission/edit/${this.selectedCommissionID}`], { queryParams: { add_deal_order: this.selectedDealId } });
  }

  async delete(currentDeal: any) {
    if (!this._authenticationService.hasCapability("delete_deal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    //No delete if deal has a commission
    if (!!currentDeal.commission && !!currentDeal.commission.id) {
      await this._utilService.showSWALError({ text: "ERROR_DEAL_HAS_A_COMMISSION" });
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentDeal.complete_name;
    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        this._utilService.showLoading();
        if (currentDeal.deal_type === "Product") {
          await this._productsDealsService
            .deleteDeal(currentDeal.id)
            .then(async () => {
              await this.loadDeals();
              await this.searchDeal();
              this._utilService.hideLoading();
              await this._utilService.showPopupItemDeleted();
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DEAL_DELETE" }));
        } else {
          await this._dealsService
            .deleteDeal(currentDeal.id)
            .then(async () => {
              await this.loadDeals();
              await this.searchDeal();
              this._utilService.hideLoading();
              await this._utilService.showPopupItemDeleted();
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DEAL_DELETE" }));
        }
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async generateDocument(id: number, regenerate: boolean, deal_type: string) {
    if (!this._authenticationService.hasCapability("manage_deal_document")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    //If is a regenerate we'll show an alert confirmation, the existing file will be replaced
    if (regenerate) {
      let confirmationText: string = await this._utilService.translate("ALERT.CONFIRM_REGENERATE_TEXT");
      await this._utilService
        .showSWALDeleteConfirmation({
          text: confirmationText,
          customClass: { confirmButton: "btn btn-success" },
          confirmButtonText: "CONFIRM_GENERATE_BTN",
        })
        .then(async (result) => {
          if (result.value) {
            this._utilService.showLoading();
            if (deal_type === "Product") {
              await this._productsDealsService
                .generateDealDocument(id)
                .then(async (response: any) => {
                  await this.loadDeals();
                  await this.searchDeal();
                  this._utilService.hideLoading();
                  await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_DOCUMENT" });
                  if (response.url.includes(".pdf")) {
                    await this._utilService.getFile(response.url);
                  }
                })
                .catch(async () => {
                  this._utilService.hideLoading();
                  await this._utilService.showSWALError({ text: "ERROR_GENERATE_DEAL_DOCUMENT" });
                });
            } else {
              await this._dealsService
                .generateDealDocument(id)
                .then(async (response: any) => {
                  await this.loadDeals();
                  await this.searchDeal();
                  this._utilService.hideLoading();
                  await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_DOCUMENT" });
                  if (response.url.includes(".pdf")) {
                    await this._utilService.getFile(response.url);
                  }
                })
                .catch(async () => {
                  this._utilService.hideLoading();
                  await this._utilService.showSWALError({ text: "ERROR_GENERATE_DEAL_DOCUMENT" });
                });
            }
          } else if (result.isDismissed) {
            await this._utilService.showSWALError({
              title: "ABORTED_TITLE",
              text: "ABORTED_GENERATE_TEXT",
            });
          }
        });
    } else {
      this._utilService.showLoading();
      if (deal_type === "Product") {
        await this._productsDealsService
          .generateDealDocument(id)
          .then(async (response: any) => {
            await this.loadDeals();
            await this.searchDeal();
            this._utilService.hideLoading();
            await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_DOCUMENT" });
            if (response.url.includes(".pdf")) {
              await this._utilService.getFile(response.url);
            }
          })
          .catch(async () => {
            this._utilService.hideLoading();
            await this._utilService.showSWALError({ text: "ERROR_GENERATE_DEAL_DOCUMENT" });
          });
      } else {
        await this._dealsService
          .generateDealDocument(id)
          .then(async (response: any) => {
            await this.loadDeals();
            await this.searchDeal();
            this._utilService.hideLoading();
            await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_DOCUMENT" });
            if (response.url.includes(".pdf")) {
              await this._utilService.getFile(response.url);
            }
          })
          .catch(async () => {
            this._utilService.hideLoading();
            await this._utilService.showSWALError({ text: "ERROR_GENERATE_DEAL_DOCUMENT" });
          });
      }
    }
  }
}
